module.exports = __webpack_public_path__ + "img/001.a689c2fd.png";